import { Route } from 'vue-router';

import store from '@/store';

const authHook = (to: Route, from: Route, next: Function) => {
  const protectedRoute = to.matched.some(record => !(record.meta.public));
  const hasToken = store.getters.TOKEN.length > 0;
  if (protectedRoute) {
    if (!hasToken) {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath,
        },
      });
    } else {
      const user = store.state.user;
      const adminOnly = to.matched.find(record => record.meta.adminOnly);
      const hasStats = to.matched.find(record => record.meta.hasStats);
      const appAdmin = to.matched.find(record => record.meta.appAdmin);
      if (user.isAppAdmin && appAdmin) {
        next()
      } else if (user.isAppAdmin && !appAdmin) {
        next({ path: '/admin' });
      } else if (adminOnly || hasStats) {
        if (adminOnly && hasStats && user.isAdmin && user.hasStats) {
          next();
        } else if (adminOnly && !hasStats && user.isAdmin) {
          next();
        } else if (!adminOnly && hasStats && user.hasStats) {
          next();
        } else {
          next({ path: '/home' });
        }
      } else {
        next();
      }
    }
  } else {
    if (hasToken) {
      next({ path: '/home' });
    } else {
      next();
    }
  }
};

export default authHook;
